import React, { useEffect, useState } from "react";
import { Button, Card, Input, Segmented, Empty } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { RoomServices } from "../Services/RoomServices";
import { navigate } from "../components/Customs/navigation";
import RoomCard from "../components/Rooms/book/RoomCard";
import HistoryRoomList from "../components/Rooms/history/HistoryRoomList";
import TitleHead from "../components/Customs/TitleHead";
import axios from "axios";
import { ENDPOINTS } from "../Services/ENDPOINT";

import { canViewModule } from "../../utils/permissionUtils"

const MODULE_KEY = 'room_history'

const SEGMENTS = [
  { label: "Available", value: "available" },
  { label: "Under Maintenance", value: "maintenance" },
  { label: "Reserved", value: "reserved" },
  { label: "Occupied", value: "occupied" },
  { label: "All", value: "all" },
];

const RoomHistoryPage = () => {
  const [rooms, setRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [activeSegment, setActiveSegment] = useState("all");
  const [searchText, setSearchText] = useState("");
  const [upcomingMap, setUpcomingMap] = useState({}); 

  const getAllRooms = async () => {
    try {
      const res = await RoomServices.getAllRoom();
      const roomsData = res?.data?.data || res?.data || [];
      setRooms(roomsData);
      if (Array.isArray(roomsData) && roomsData.length > 0) {
        setSelectedRoom(roomsData[0]);
      }
    } catch (error) {
      console.error("Failed to fetch rooms:", error);
      setRooms([]);
    }
  };

  const getUpcomingReservations = async () => {
    try {
      const res = await axios.get(ENDPOINTS.UPCOMING_RESERVATIONS);
      const data = res.data?.data || [];
      // Group by room_id
      const map = {};
      data.forEach((b) => {
        if (!map[b.room_id]) map[b.room_id] = [];
        map[b.room_id].push(b);
      });
      console.log("map",map);
      
      setUpcomingMap(map);
    } catch (err) {
      console.error("Failed to fetch upcoming reservations", err);
    }
  };

  useEffect(() => {
    getAllRooms();
    getUpcomingReservations();
  }, []);

    if (!canViewModule(MODULE_KEY)) {
    return <Empty description="No permission to view this page" />
  }


  

  const filteredRooms = rooms.filter((r) => {
    const matchesSegment =
      activeSegment === "all"
        ? true
        : r.status?.toLowerCase() === activeSegment.toLowerCase();

    const matchesSearch =
      r.room_name?.toLowerCase().includes(searchText.toLowerCase()) ||
      r.room_number?.toString().includes(searchText);

    return matchesSegment && matchesSearch;
  });

  console.log("filteredRooms", filteredRooms);

  return (
    <Card
      className="room-management-card"
      title={
        <TitleHead h1='View Room History' h2='Past bookings, guest stays & room usage timeline overview' />
      }
      extra={
        <Input.Search
          placeholder="Search rooms by name or number"
          allowClear
          size="large"
          style={{ width: 400 }}
          onChange={(e) => setSearchText(e.target.value)}
          onSearch={(value) => setSearchText(value)}
        />
      }
    >
      <HistoryRoomList
        dataSource={filteredRooms}
        selectedRow={selectedRoom}
        onRowSelect={setSelectedRoom}
        upcomingMap={upcomingMap}  
      />
    </Card>
  );
};

export default RoomHistoryPage;